export const types = {
  CLEAN_TRANSCRIPTS: 'CLEAN_TRANSCRIPTS',
  GET: {
    LIST: {
      STARTED: 'GET_TRANSCRIPTS_LIST_STARTED',
      FAILURE: 'GET_TRANSCRIPTS_LIST_FAILURE',
      SUCCESS: 'GET_TRANSCRIPTS_LIST_SUCCESS',
    },
    CLOUD_SEARCH_LIST: {
      STARTED: 'GET_TRANSCRIPTS_CLOUD_SEARCH_LIST_STARTED',
      FAILURE: 'GET_TRANSCRIPTS_CLOUD_SEARCH_LIST_FAILURE',
      SUCCESS: 'GET_TRANSCRIPTS_CLOUD_SEARCH_LIST_SUCCESS',
    },
    TRANSCRIPT_RECORDINGS_LINKS: {
      STARTED: 'GET_TRANSCRIPT_RECORDINGS_LINKS_STARTED',
      FAILURE: 'GET_TRANSCRIPT_RECORDINGS_LINKS_FAILURE',
      SUCCESS: 'GET_TRANSCRIPT_RECORDINGS_LINKS_SUCCESS',
      CLEAR: 'GET_TRANSCRIPT_RECORDINGS_LINKS_CLEAR',
    },
  },
  SET_TRANSCRIPTS_FILTER: 'SET_TRANSCRIPTS_FILTER',
  SET_TRANSCRIPTS_ORDER: 'SET_TRANSCRIPTS_ORDER',
  CLEAR_FILTERS: 'CLEAR_FILTERS',
  RESUBMIT_TRANSCRIPT: {
    STARTED: 'RESUBMIT_TRANSCRIPT_STARTED',
    FAILURE: 'RESUBMIT_TRANSCRIPT_FAILURE',
    SUCCESS: 'RESUBMIT_TRANSCRIPT_SUCCESS',
  },
};

export const cleanTranscripts = () => ({ type: types.CLEAN_TRANSCRIPTS });

export const getTranscriptsList = (pageNumber, numberPerPage, filters) => ({
  type: types.GET.LIST.STARTED,
  pageNumber,
  numberPerPage,
  filters,
});

export const getTranscriptsListSuccess = ({ list, meta }) => ({
  type: types.GET.LIST.SUCCESS,
  list,
  meta,
});

export const getTranscriptsListFailure = () => ({
  type: types.GET.LIST.FAILURE,
});

export const getCloudSearchTranscriptsList = (payload) => ({
  type: types.GET.CLOUD_SEARCH_LIST.STARTED,
  payload,
});

export const getCloudSearchTranscriptsListSuccess = (payload) => ({
  type: types.GET.CLOUD_SEARCH_LIST.SUCCESS,
  payload,
});

export const getCloudSearchTranscriptsListFailure = () => ({
  type: types.GET.CLOUD_SEARCH_LIST.FAILURE,
});

export const setTranscriptsFilter = (field, value) => ({
  type: types.SET_TRANSCRIPTS_FILTER,
  field,
  value,
});

export const setTranscriptsOrder = (field, value) => ({
  type: types.SET_TRANSCRIPTS_ORDER,
  field,
  value,
});

export const resubmitTranscript = (transcriptId) => ({
  type: types.RESUBMIT_TRANSCRIPT.STARTED,
  transcriptId,
});
export const resubmitTranscriptSuccess = (transcriptId) => ({
  type: types.RESUBMIT_TRANSCRIPT.SUCCESS,
  transcriptId,
});
export const resubmitTranscriptFailure = (transcriptId) => ({
  type: types.RESUBMIT_TRANSCRIPT.FAILURE,
  transcriptId,
});

export const clearFilters = () => ({ type: types.CLEAR_FILTERS });

export const getAudioLinksById = (id) => ({
  type: types.GET.TRANSCRIPT_RECORDINGS_LINKS.STARTED,
  id,
});

export const getAudioLinksByIdSuccess = (payload) => ({
  type: types.GET.TRANSCRIPT_RECORDINGS_LINKS.SUCCESS,
  payload,
});

export const getAudioLinksByIdFailure = (message) => ({
  type: types.GET.TRANSCRIPT_RECORDINGS_LINKS.FAILURE,
  message,
});

export const clearAudioLinks = () => ({
  type: types.GET.TRANSCRIPT_RECORDINGS_LINKS.CLEAR,
});



// WEBPACK FOOTER //
// ./redux/actions/transcripts.js